import { PaymentType, PaymentTypeLabel } from '../context/buy_context'
import {
    CashierExpectedAmountInfo,
    CashierHistoric,
    CashierValueEnum,
} from '../context/cashier_context'
import { ClientDocumentType } from '../context/client_context'
import { CoinInfo, CoinType } from '../context/coin_context'
import {
    ConfigsInfo,
    PromissoryNodeMode,
    TicketType,
} from '../context/configs_context'
import {
    PaymentInSale,
    PreSaleInfo,
    SaleInfo,
    SaleStatus,
} from '../context/sale_context'
import { NationalityEnum } from '../context/supplier_context'
import {
    breakText,
    getDateInDDMMYYYYFormat,
    getDateString,
    getExchangeValue,
    maskCurrency,
    normalizeString,
    numeroPorExtensoEspanhol,
} from './maks'

export function getSalePrintText(
    sale: SaleInfo,
    configs: ConfigsInfo,
    coins: CoinInfo[],
    selectedCoin?: CoinInfo
) {
    selectedCoin = selectedCoin ?? sale.coin

    const totals =
        selectedCoin?.id !== sale.coin?.id
            ? sale.totalSecondaryCoin?.find(
                  (v) => v.coinId === selectedCoin?.id
              )!
            : sale

    const contacts = sale.branch ? sale.branch.contacts : configs.contacts
    const companyName =
        sale.branch && configs.showBranchNameInNote
            ? sale.branch.name
            : configs.companyName
    const companySlogan = sale.branch?.companySlogan
        ? sale.branch.companySlogan
        : configs.companySlogan
    const companyDocument = sale.branch?.companyDocument
        ? sale.branch.companyDocument
        : configs.companyDocument

    const totalChange = sale.payments.reduce((total, payment) => {
        const change = payment.changes.reduce((total, current) => {
            if (selectedCoin?.id !== current.coin?.id) {
                const coinExchange = selectedCoin?.exchanges.find(
                    (e) => e.coin.id === current.coin?.id
                )

                return (
                    total +
                    getExchangeValue({
                        amount: current.value,
                        coinExchangeType:
                            coinExchange?.flagReverseExchange ?? 0,
                        exchange: coinExchange?.saleExchange ?? 0,
                        order: 'reverse',
                    })
                )
            }

            return total + current.value
        }, 0)

        return total + change
    }, 0)

    const title = normalizeString(companyName ?? '')

    const getBoard = () => '-'.repeat(30)

    return normalizeString(`${getBoard()}
${title}
${
    sale.note || configs.ticketType === TicketType.Complete
        ? `${companySlogan}
${contacts.map((contact) => contact.value).join('\n')}
${getBoard()}
`
        : ''
}
${
    sale.note
        ? `RUC: ${companyDocument}
Timbrado: ${sale.note.timbrado}
Fecha inicio vigencia: ${getDateInDDMMYYYYFormat(sale.note.iniD)}
Fecha fim vigencia: ${
              sale.note.endD ? getDateInDDMMYYYYFormat(sale.note.endD) : '---'
          }
Numero factura: ${sale.bill}
${getBoard()}`
        : ''
}
Numero venta: ${sale.id}
${
    sale.note
        ? `Factura: ${
              (sale.paymentTypeShow === PaymentType.Credit ||
                  sale.paymentTypeShow === PaymentType.Parcel) &&
              !configs.showOnlyNormalPaymentType
                  ? 'CRÉDITO'
                  : 'CONTADO'
          }
Caja: ${sale.cashier?.name}`
        : ''
}
Cliente: ${sale.client?.name || 'xxx'}
${
    sale.note || configs.ticketType === TicketType.Complete
        ? `${
              sale.client?.documentType === ClientDocumentType.RUC
                  ? 'RUC'
                  : 'Documento'
          } cliente: ${sale.client?.document || 'xxx'}
Direccion cliente: ${sale.client?.address || 'xxx'}
Vendedor: ${sale.employee?.name || 'xxx'}
Condición: ${
              typeof sale.paymentType === 'number'
                  ? PaymentTypeLabel[sale.paymentType]
                  : 'xxx'
          }`
        : ''
}
Fecha: ${
        sale.noteDate
            ? getDateString({
                  date: sale.noteDate,
                  hour: sale.noteHour,
                  isSummerTime: sale.isNoteSummerTime ?? false,
                  configs: configs,
              })
            : getDateString({
                  date: sale.date,
                  hour: sale.hour,
                  isSummerTime: sale.isSummerTime ?? false,
                  configs: configs,
              })
    }
${getBoard()}
CODB.           DESC
      P.U.xCANT      IMPORTE
${getBoard()}
${sale.products
    .map((p) => {
        const noteProduct = sale.note ? p.noteProduct ?? p.product : p.product

        const values =
            selectedCoin?.id !== sale.coin?.id
                ? p.valueSecondaryCoin?.find(
                      (v) => v.coinId === selectedCoin?.id
                  )!
                : p

        const description = `${noteProduct.barcodes[0]}-${noteProduct.name}`
        return `${
            description.length > 30 && configs.ticketType === TicketType.Reduced
                ? description.slice(0, 30) + '...'
                : description
        }
${p.qnt} X ${maskCurrency(values?.notePrice, selectedCoin)}   ${maskCurrency(
            values?.notePrice * p.qnt,
            selectedCoin
        )}`
    })
    .join('\n')}
${getBoard()}
${
    sale.note
        ? `Subtotais
Exento: ${maskCurrency(totals?.totalExcept ?? 0, selectedCoin)}
Total 5%: ${maskCurrency(totals?.totalFivePercent ?? 0, selectedCoin)}
Total 10%: ${maskCurrency(totals?.totalTenPercent ?? 0, selectedCoin)}
${getBoard()}
Liquidacion IVA:
Total 5%: ${maskCurrency(totals?.totalIvaFivePercent ?? 0, selectedCoin)}
Total 10%: ${maskCurrency(totals?.totalIvaTenPercent ?? 0, selectedCoin)}
Total: ${maskCurrency(totals?.totalIva ?? 0, selectedCoin)}
${getBoard()}`
        : ''
}
Valor total: ${maskCurrency(totals?.total, selectedCoin)}
Total entregado: ${maskCurrency(
        sale.payments.reduce((current, payment) => {
            let amountPayed = payment.amountPayed

            if (selectedCoin?.id !== sale.coin?.id) {
                const coinExchange = sale.coin?.exchanges.find(
                    (e) => e.coin.id === selectedCoin?.id
                )

                const exchange = sale.totalSecondaryCoin?.find(
                    (t) => t.coinId === selectedCoin?.id
                )?.exchange

                amountPayed = getExchangeValue({
                    amount: amountPayed,
                    coinExchangeType: coinExchange?.flagReverseExchange ?? 0,
                    exchange: exchange ?? 0,
                    order: 'normal',
                })
            }

            return current + amountPayed + totalChange
        }, 0),
        selectedCoin
    )}
Vuelto: ${maskCurrency(
        sale.payments.reduce((current, payment) => {
            const change = payment.changes.reduce((total, current) => {
                if (selectedCoin?.id !== current.coin?.id) {
                    const coinExchange = selectedCoin?.exchanges.find(
                        (e) => e.coin.id === current.coin?.id
                    )

                    const exchange = sale.totalSecondaryCoin?.find(
                        (t) => t.coinId === selectedCoin?.id
                    )?.exchange

                    return (
                        total +
                        getExchangeValue({
                            amount: current.value,
                            coinExchangeType:
                                coinExchange?.flagReverseExchange ?? 0,
                            exchange: exchange ?? 0,
                            order: 'normal',
                        })
                    )
                }

                return total + current.value
            }, 0)

            return current + change
        }, 0),
        selectedCoin
    )}
${getBoard()}
${
    configs.showSecondaryCoinTotalsTicket && sale.coin?.id === selectedCoin?.id
        ? `${sale.totalSecondaryCoin
              ?.map((total) => {
                  const coin = coins.find((coin) => coin.id === total.coinId)
                  return `Valor total en ${
                      coin?.name.toLowerCase() + 'es'
                  }: ${maskCurrency(total.total, coin)}`
              })
              .join('\n')}
${getBoard()}
`
        : ''
}
${
    sale.note
        ? `Esta factura es tu comprobante
Original: cliente
Duplicado: Arquivo tributario`
        : `Ticket de control interno.
${
    !!sale.client?.id
        ? `Deuda total: ${sale.client?.coin?.symbol} ${maskCurrency(
              sale.client?.creditUsed ?? 0,
              sale.client?.coin
          )}`
        : ''
}`
}
${
    sale.saleStatus === SaleStatus.Open &&
    sale.paymentTypeShow === PaymentType.Credit &&
    configs.promissoryNoteMode !== PromissoryNodeMode.DontShow
        ? ` 
 
 
PAGARE A LA ORDEN
${getBoard()}
Numero venta: ${sale.id}
Factura: ${configs.showOnlyNormalPaymentType ? 'CONTADO' : 'CRÉDITO'}
Caja: ${sale.cashier?.name}
Cliente: ${sale.client?.name ?? 'xxx'}
RUC cliente: ${sale.client?.document ?? 'xxx'}
Direccion cliente: ${sale.client?.address ?? 'xxx'}
Fecha: ${
              sale.noteDate
                  ? getDateString({
                        date: sale.noteDate,
                        hour: sale.noteHour,
                        isSummerTime: sale.isNoteSummerTime ?? false,
                        configs: configs,
                    })
                  : getDateString({
                        date: sale.date,
                        hour: sale.hour,
                        isSummerTime: sale.isSummerTime ?? false,
                        configs: configs,
                    })
          }
${getBoard()}
${
    configs.promissoryNoteMode === PromissoryNodeMode.Complete &&
    `CODB.           DESC
      P.U.xCANT      IMPORTE
${getBoard()} 
${sale.products
    .map((p) => {
        const noteProduct = sale.note ? p.noteProduct ?? p.product : p.product

        const values =
            selectedCoin?.id !== sale.coin?.id
                ? p.valueSecondaryCoin?.find(
                      (v) => v.coinId === selectedCoin?.id
                  )!
                : p

        const description = `${noteProduct.barcodes[0]}-${noteProduct.name}`
        return `${
            description.length > 30 && configs.ticketType === TicketType.Reduced
                ? description.slice(0, 30) + '...'
                : description
        }
${p.qnt} X ${maskCurrency(values?.notePrice, selectedCoin)}   ${maskCurrency(
            values?.notePrice * p.qnt,
            selectedCoin
        )}`
    })
    .join('\n')}
${getBoard()} `
}
Total: ${maskCurrency(totals?.total, selectedCoin)}
 
PAGARE A LA ORDEN
La falta de pago del documento originara
automaticamente un interes ${sale.client?.fees}%
diario apos ${sale.client?.creditDays} dias de
realizada la compra.
Autorizo(amos) desde ya al acreedor a la consulta
como a la base de datos de INFORMACIONES
COMERCIALES, confirme a lo estabelecido em la ley
1686/02.
Todas las partes intervinientes en este documento se
somenten a la juridiccion y competencia de los
jueces y declaran prorrogadas desde ya cualquier
otra que pudiera corresponder.
 
Firma: ____________________________
C.I: ${sale.client?.document}
Deuda total: ${sale.client?.coin?.symbol} ${maskCurrency(
              sale.client?.creditUsed ?? 0,
              sale.client?.coin
          )}
`
        : ''
}`)
        .split('\n')
        .filter((l) => l)
        .join('\n')
}

export function getCommonNoteSalePrintText(
    sale: SaleInfo,
    configs: ConfigsInfo,
    selectedCoin?: CoinInfo
) {
    const companyName =
        sale.branch && configs.showBranchNameInNote
            ? sale.branch.name
            : configs.companyName
    const companySlogan = sale.branch?.companySlogan
        ? sale.branch.companySlogan
        : configs.companySlogan

    selectedCoin = selectedCoin ?? sale.coin

    const totals =
        selectedCoin?.id !== sale.coin?.id
            ? sale.totalSecondaryCoin?.find(
                  (v) => v.coinId === selectedCoin?.id
              )!
            : sale

    const LENGTH = 96
    let printerRows = 30
    let baseContentRows = 15
    let maxProductTableLinesPerSale = printerRows - baseContentRows
    let remainingLinesForProducts = maxProductTableLinesPerSale
    let stopIncreasingProducts = false
    let productsUsed = 0
    const getBoard = () => '-'.repeat(LENGTH)

    const getProductTable = (texts: string[], fixedLength: number[]) => {
        if (stopIncreasingProducts) return ''

        const finalTexts: string[][] = []

        for (let i = 0; i < texts.length; i++) {
            const contentLength = fixedLength[i] * LENGTH
            const finalText = breakText(texts[i], contentLength - 1).split('\n')

            for (let j = 0; j < finalText.length; j++) {
                if (!finalTexts[j])
                    finalTexts[j] = texts.map((_, h) =>
                        ' '.repeat(fixedLength[h] * LENGTH - 1)
                    )

                const diff = contentLength - finalText[j].length
                finalTexts[j][i] = finalText[j] + ' '.repeat(diff)
            }
        }

        if (finalTexts.length > remainingLinesForProducts) {
            stopIncreasingProducts = true
            return ''
        } else {
            remainingLinesForProducts -= finalTexts.length
            productsUsed++
        }

        const finalTextsFormatted: string[] = []

        for (let i = 0; i < finalTexts.length; i++) {
            const remainingSize =
                LENGTH -
                finalTexts[i].reduce(
                    (total, current) => total + current.length,
                    0
                )

            finalTextsFormatted[i] = finalTexts[i].join(
                ' '.repeat(
                    Math.floor(remainingSize / (finalTexts[i].length - 1))
                )
            )
        }

        return finalTextsFormatted.join('\n')
    }

    const getTextInLine = (texts: string[], fixedLength?: number[]) => {
        if (fixedLength && fixedLength.length === texts.length) {
            for (let i = 0; i < texts.length; i++) {
                const contentLength = fixedLength[i] * LENGTH
                texts[i] = texts[i].slice(0, contentLength - 1)
                const diff = contentLength - texts[i].length
                texts[i] = texts[i] + ' '.repeat(diff)
            }
        }

        const remainingSize =
            LENGTH - texts.reduce((total, current) => total + current.length, 0)
        return texts.join(
            ' '.repeat(Math.floor(remainingSize / (texts.length - 1)))
        )
    }

    const content = normalizeString(`${getTextInLine([
        '',
        companyName ?? '',
        '',
    ])}
${getBoard()}
Número venta: ${sale.id}
${getTextInLine([
    `Cliente: ${sale.client?.name}`,
    `Fecha: ${getDateString({
        date: sale.date,
        hour: sale.hour,
        isSummerTime: sale.isSummerTime ?? false,
        configs: configs,
    })}`,
])}
${getTextInLine([
    `${
        sale.client?.documentType === ClientDocumentType.RUC
            ? 'Ruc'
            : 'Documento'
    }: ${sale.client?.document || 'xxx'}`,
    `Telefonos: ${sale.client?.phoneNumbers.join(', ') || 'xxx'}`,
])}
${getTextInLine([
    `Dirección: ${sale.client?.address || 'xxx'}`,
    `Vendedor: ${sale.employee?.name || 'xxx'}`,
])}
${getBoard()}
${getTextInLine(
    [`CÓDIGO BAR.`, 'CANT. / DESC', 'PESO', 'P. UNIT', 'SUBTOTAL'],
    [0.2, 0.4, 0.1, 0.15, 0.15]
)}
${getBoard()}
${sale.products
    .map((p) => {
        const noteProduct = sale.note ? p.noteProduct ?? p.product : p.product

        const values =
            selectedCoin?.id !== sale.coin?.id
                ? p.valueSecondaryCoin?.find(
                      (v) => v.coinId === selectedCoin?.id
                  )!
                : p

        return getProductTable(
            [
                noteProduct.barcodes[0],
                `${Number(p.qnt)} / ${noteProduct.name}`,
                `${p.product.realWeight * p.qnt} Kg`,
                maskCurrency(values?.notePrice, selectedCoin),
                maskCurrency(values?.notePrice * p.qnt, selectedCoin),
            ],
            [0.2, 0.4, 0.1, 0.15, 0.15]
        )
    })
    .filter((t) => t)
    .join('\n')}
${getBoard()}${'\n'.repeat(remainingLinesForProducts)}
${getTextInLine([
    `Total: ${numeroPorExtensoEspanhol(totals?.total, selectedCoin)}`.slice(
        0,
        LENGTH - maskCurrency(totals?.total ?? 0, selectedCoin).length - 1
    ),
    maskCurrency(totals?.total ?? 0, selectedCoin),
])}
${getTextInLine([
    `Peso total:`,
    `${sale.products.reduce(
        (total, curr) => total + curr.product.realWeight * curr.qnt,
        0
    )} kg`,
])}
${getBoard()}
Nota: ${sale.observation || '---'}
Obs: DEVOLUCIONES HASTA 48 HORAS DESPUÉS DE LA EMISION DE LA FACTURA${'\n'.repeat(
        4
    )}`)

    const ESC = '\x1B'
    const reset = ESC + '@'
    const condensado = ESC + '!' + '\x01'

    let finalContent = ''
    finalContent = reset + condensado

    finalContent += content

    return {
        content: finalContent,
        productsUsed,
        maxProductTableLinesPerSale,
        remainingLinesForProducts,
    }
}

export function getBudgetPrintText(
    budget: PreSaleInfo,
    configs: ConfigsInfo,
    coins: CoinInfo[]
) {
    const selectedCoin = budget.coin
    const totals = budget

    const contacts = budget.branch ? budget.branch.contacts : configs.contacts
    const companyName =
        budget.branch && configs.showBranchNameInNote
            ? budget.branch.name
            : configs.companyName
    const companySlogan = budget.branch?.companySlogan
        ? budget.branch.companySlogan
        : configs.companySlogan

    const title = normalizeString(companyName ?? '')

    const getBoard = () => '-'.repeat(30)

    return normalizeString(`${getBoard()}
${title}
${
    configs.ticketType === TicketType.Complete
        ? `${companySlogan}
${contacts.map((contact) => contact.value).join('\n')}
${getBoard()}
`
        : ''
}
Numero presupuesto: ${budget.id}
Cliente: ${budget.client?.name ?? 'xxx'}
${
    configs.ticketType === TicketType.Complete
        ? `Vendedor: ${budget.employee?.name}
Caja: ${budget.cashier?.name}
RUC cliente: ${budget.client?.document ?? 'xxx'}
Direccion cliente: ${budget.client?.address ?? 'xxx'}
Telefono cliente: ${budget.client?.phoneNumbers.join(', ') ?? 'xxx'}`
        : ''
}
Fecha: ${getDateString({
        date: budget.date,
        hour: budget.hour,
        isSummerTime: budget.isSummerTime ?? false,
        configs: configs,
    })}
${getBoard()}
CODB.           DESC
      P.U.xCANT      IMPORTE
${getBoard()}
${budget.products
    .map((p) => {
        const noteProduct = p.product

        const values = p

        const description = `${noteProduct.barcodes[0]}-${noteProduct.name}`
        return `${
            description.length > 30 && configs.ticketType === TicketType.Reduced
                ? description.slice(0, 30) + '...'
                : description
        }
${p.qnt} X ${maskCurrency(values?.notePrice, selectedCoin)}   ${maskCurrency(
            values?.notePrice * p.qnt,
            selectedCoin
        )}`
    })
    .join('\n')}
${getBoard()}
Valor total: ${maskCurrency(totals?.total, selectedCoin)}
${getBoard()}
${
    configs.showSecondaryCoinTotalsTicket
        ? `${coins
              .filter((c) => c.id !== selectedCoin?.id)
              ?.map((coin) => {
                  const exchange = selectedCoin?.exchanges.find(
                      (e) => e.coin.id === coin.id
                  )

                  const total = getExchangeValue({
                      amount: budget.total,
                      coinExchangeType: exchange?.flagReverseExchange ?? 0,
                      exchange: exchange?.saleExchange ?? 0,
                      order: 'normal',
                  })
                  return `Valor total en ${
                      coin?.name.toLowerCase() + 'es'
                  }: ${maskCurrency(total, coin)}`
              })
              .join('\n')}
${getBoard()}
`
        : ''
}`)
        .split('\n')
        .filter((l) => l)
        .join('\n')
}

export function getBudgetMatrixPrintText(
    budget: PreSaleInfo,
    configs: ConfigsInfo
) {
    const companyName =
        budget.branch && configs.showBranchNameInNote
            ? budget.branch.name
            : configs.companyName
    const companySlogan = budget.branch?.companySlogan
        ? budget.branch.companySlogan
        : configs.companySlogan

    const selectedCoin = budget.coin

    const totals = budget

    const LENGTH = 96
    let printerRows = 30
    let baseContentRows = 15
    let maxProductTableLinesPerSale = printerRows - baseContentRows
    let remainingLinesForProducts = maxProductTableLinesPerSale
    let stopIncreasingProducts = false
    let productsUsed = 0
    const getBoard = () => '-'.repeat(LENGTH)

    const getProductTable = (texts: string[], fixedLength: number[]) => {
        if (stopIncreasingProducts) return ''

        const finalTexts: string[][] = []

        for (let i = 0; i < texts.length; i++) {
            const contentLength = fixedLength[i] * LENGTH
            const finalText = breakText(texts[i], contentLength - 1).split('\n')

            for (let j = 0; j < finalText.length; j++) {
                if (!finalTexts[j])
                    finalTexts[j] = texts.map((_, h) =>
                        ' '.repeat(fixedLength[h] * LENGTH - 1)
                    )

                const diff = contentLength - finalText[j].length
                finalTexts[j][i] = finalText[j] + ' '.repeat(diff)
            }
        }

        if (finalTexts.length > remainingLinesForProducts) {
            stopIncreasingProducts = true
            return ''
        } else {
            remainingLinesForProducts -= finalTexts.length
            productsUsed++
        }

        const finalTextsFormatted: string[] = []

        for (let i = 0; i < finalTexts.length; i++) {
            const remainingSize =
                LENGTH -
                finalTexts[i].reduce(
                    (total, current) => total + current.length,
                    0
                )

            finalTextsFormatted[i] = finalTexts[i].join(
                ' '.repeat(
                    Math.floor(remainingSize / (finalTexts[i].length - 1))
                )
            )
        }

        return finalTextsFormatted.join('\n')
    }

    const getTextInLine = (texts: string[], fixedLength?: number[]) => {
        if (fixedLength && fixedLength.length === texts.length) {
            for (let i = 0; i < texts.length; i++) {
                const contentLength = fixedLength[i] * LENGTH
                texts[i] = texts[i].slice(0, contentLength - 1)
                const diff = contentLength - texts[i].length
                texts[i] = texts[i] + ' '.repeat(diff)
            }
        }

        const remainingSize =
            LENGTH - texts.reduce((total, current) => total + current.length, 0)
        return texts.join(
            ' '.repeat(Math.floor(remainingSize / (texts.length - 1)))
        )
    }

    const content = normalizeString(`${getTextInLine([
        '',
        companyName ?? '',
        '',
    ])}
${getBoard()}
Número presupuesto: ${budget.id}
${getTextInLine([
    `Cliente: ${budget.client?.name}`,
    `Fecha: ${getDateString({
        date: budget.date,
        hour: budget.hour,
        isSummerTime: budget.isSummerTime ?? false,
        configs: configs,
    })}`,
])}
${getTextInLine([
    `${
        budget.client?.documentType === ClientDocumentType.RUC
            ? 'Ruc'
            : 'Documento'
    }: ${budget.client?.document || 'xxx'}`,
    `Telefonos: ${budget.client?.phoneNumbers.join(', ') || 'xxx'}`,
])}
${getTextInLine([
    `Dirección: ${budget.client?.address || 'xxx'}`,
    `Vendedor: ${budget.employee?.name || 'xxx'}`,
])}
${getBoard()}
${getTextInLine(
    [`CÓDIGO BAR.`, 'CANT. / DESC', 'PESO', 'P. UNIT', 'SUBTOTAL'],
    [0.2, 0.4, 0.1, 0.15, 0.15]
)}
${getBoard()}
${budget.products
    .map((p) => {
        const noteProduct = p.product
        const values = p

        return getProductTable(
            [
                noteProduct.barcodes[0],
                `${Number(p.qnt)} / ${noteProduct.name}`,
                `${p.product.realWeight * p.qnt} Kg`,
                maskCurrency(values?.notePrice, selectedCoin),
                maskCurrency(values?.notePrice * p.qnt, selectedCoin),
            ],
            [0.2, 0.4, 0.1, 0.15, 0.15]
        )
    })
    .filter((t) => t)
    .join('\n')}
${getBoard()}${'\n'.repeat(remainingLinesForProducts)}
${getTextInLine([
    `Total: ${numeroPorExtensoEspanhol(totals?.total, selectedCoin)}}`.slice(
        0,
        LENGTH - maskCurrency(totals?.total ?? 0, selectedCoin).length - 1
    ),
    maskCurrency(totals?.total ?? 0, selectedCoin),
])}
${getTextInLine([
    `Peso total:`,
    `${budget.products.reduce(
        (total, curr) => total + curr.product.realWeight * curr.qnt,
        0
    )} kg`,
])}
${getBoard()}
Nota: ${budget.annotation || '---'}
Obs: DEVOLUCIONES HASTA 48 HORAS DESPUÉS DE LA EMISION DE LA FACTURA${'\n'.repeat(
        4
    )}`)

    const ESC = '\x1B'
    const reset = ESC + '@'
    const condensado = ESC + '!' + '\x01'

    let finalContent = ''
    finalContent = reset + condensado

    finalContent += content

    return {
        content: finalContent,
        productsUsed,
        maxProductTableLinesPerSale,
        remainingLinesForProducts,
    }
}

export function getCashierPrintText(
    cashierHistoric: CashierHistoric,
    cashierExpectedAmounts: CashierExpectedAmountInfo,
    configs: ConfigsInfo,
    coins: CoinInfo[]
) {
    const contacts = configs.contacts
    const companyName = configs.companyName
    const companySlogan = configs.companySlogan

    const title = normalizeString(companyName ?? '')

    const getBoard = () => '-'.repeat(30)

    return normalizeString(`${getBoard()}
${title}
${
    configs.ticketType === TicketType.Complete
        ? `${companySlogan}
${contacts.map((contact) => contact.value).join('\n')}
${getBoard()}
`
        : ''
}
Caixa: ${cashierHistoric.cashier.name}
Fecha início: ${getDateString({
        date: cashierHistoric.openingDate,
        hour: cashierHistoric.openingHour,
        configs: configs,
        isSummerTime: cashierHistoric.isSummerTime,
    })}
Fecha fim: ${
        cashierHistoric.closingDate
            ? getDateString({
                  date: cashierHistoric.closingDate,
                  hour: cashierHistoric.closingHour,
                  configs: configs,
                  isSummerTime: cashierHistoric.isSummerTime,
              })
            : '---'
    }
Valores entrada: ${cashierHistoric.values
        .filter((v) => v.type === CashierValueEnum.Initial)
        .map((v) => `${v.coin?.symbol} ${maskCurrency(v.value, v.coin)}`)
        .join(', ')}
Valores Saída: ${cashierHistoric.values
        .filter((v) => v.type === CashierValueEnum.Final)
        .map((v) => `${v.coin?.symbol} ${maskCurrency(v.value, v.coin)}`)
        .join(', ')}
${getBoard()}
INIC. ENT. SAL. ESP.
${getBoard()}
${cashierExpectedAmounts.general
    .map((cashierExpectedAmount, i, a) => {
        return `${maskCurrency(
            cashierExpectedAmount.initialValue,
            cashierExpectedAmount.coin
        )} ${maskCurrency(
            cashierExpectedAmount.initialValue,
            cashierExpectedAmount.coin
        )} ${maskCurrency(
            cashierExpectedAmount.initialValue,
            cashierExpectedAmount.coin
        )} ${maskCurrency(
            cashierExpectedAmount.expectedAmount,
            cashierExpectedAmount.coin
        )}`
    })
    .join('\n')}
${getBoard()}`)
        .split('\n')
        .filter((l) => l)
        .join('\n')
}

export function getPaymentPrintText(
    payment: PaymentInSale,
    configs: ConfigsInfo,
    coins: CoinInfo[]
) {
    const contacts = payment.sale?.branch
        ? payment.sale.branch.contacts
        : configs.contacts
    const companyName =
        payment.sale?.branch && configs.showBranchNameInNote
            ? payment.sale.branch.name
            : configs.companyName
    const companySlogan = payment.sale?.branch?.companySlogan
        ? payment.sale.branch.companySlogan
        : configs.companySlogan
    const companyDocument = payment.sale?.branch?.companyDocument
        ? payment.sale.branch.companyDocument
        : configs.companyDocument

    const feesPayed = configs.removeFeesFromReceipt ? payment.feesPayed : 0
    const totalEntry =
        payment.amountPayed +
        payment.discount +
        payment.creditDiscount -
        feesPayed

    const getSales = () => {
        const sales: { sale: SaleInfo; amountPayed: number; date: string }[] =
            []

        if (payment.sale)
            sales.push({
                sale: payment.sale,
                amountPayed: totalEntry,
                date: getDateString({
                    date: payment.sale?.date,
                    hour: payment.sale?.hour,
                    configs: configs,
                    isSummerTime: !!payment.sale?.isSummerTime,
                }),
            })
        if (payment.prevPayments)
            sales.push(
                ...payment.prevPayments.map((p) => {
                    const feesPayed = configs.removeFeesFromReceipt
                        ? p.feesPayed
                        : 0

                    return {
                        sale: p.sale as SaleInfo,
                        amountPayed:
                            p.amountPayed +
                            p.discount +
                            p.creditDiscount -
                            feesPayed,
                        date: getDateString({
                            date: p.sale?.date,
                            hour: p.sale?.hour,
                            configs: configs,
                            isSummerTime: !!p.sale?.isSummerTime,
                        }),
                    }
                })
            )

        return sales
    }

    const coin = !payment.exchange ? payment.paymentCoin : payment.sale?.coin
    const client = payment.prevPayments?.length
        ? payment.prevPayments[0].sale?.client
        : payment.sale?.client

    const creditNotes = getSales().flatMap((s) => s.sale.creditNotes ?? [])

    const title = normalizeString(companyName ?? '')

    const getBoard = () => '-'.repeat(30)

    return normalizeString(`${getBoard()}
${title}
${companySlogan}
${contacts.map((contact) => contact.value).join('\n')}
${getBoard()}
RECIBO DE DINERO
${
    payment.note
        ? `RUC: ${companyDocument}
Timbrado: ${payment.note.timbrado}
Fecha inicio vigencia: ${getDateInDDMMYYYYFormat(payment.note.iniD)}
Fecha fim vigencia: ${
              payment.note.endD
                  ? getDateInDDMMYYYYFormat(payment.note.endD)
                  : '---'
          }
Numero factura: ${payment.bill}
${getBoard()}`
        : ''
}
Cliente: ${client?.name || 'xxx'}
Caja: ${payment.cashier?.name}
RUC cliente: ${client?.document || 'xxx'}
Direccion cliente: ${client?.address || 'xxx'}
Telefono cliente: ${client?.phoneNumbers.join(', ') || 'xxx'}
Fecha: ${
        payment.noteDate
            ? getDateString({
                  date: payment.noteDate,
                  hour: payment.noteHour,
                  isSummerTime: payment.isNoteSummerTime ?? false,
                  configs: configs,
              })
            : getDateString({
                  date: payment.date,
                  hour: payment.hour,
                  isSummerTime: payment.isSummerTime ?? false,
                  configs: configs,
              })
    }
${getBoard()}
En concepto del pago de las facturas:
${getSales()
    .map(
        (sale) =>
            `${sale.sale.bill ?? sale.sale.id} - ${
                sale.date.split(' ')[0]
            } - ${maskCurrency(sale.amountPayed, sale.sale.coin)}`
    )
    .join('\n')}
Nota(s) de crédito:
${
    creditNotes
        .map(
            (creditNote) =>
                `${creditNote.bill ?? creditNote.id} - ${
                    getDateString({
                        date: creditNote?.date,
                        hour: creditNote?.hour,
                        configs: configs,
                        isSummerTime: !!creditNote?.isSummerTime,
                    }).split(' ')[0]
                } - ${maskCurrency(creditNote.total, creditNote.coin)}`
        )
        .join('\n') || '---'
}
${getBoard()}
Detalles del pago:
Capital: 0
Interés: ${maskCurrency(0, coin)}
Entrega: ${maskCurrency(totalEntry, coin)}
En letras: ${numeroPorExtensoEspanhol(totalEntry, coin ?? undefined)}
${client?.id 
    ? `Deuda total: ${client.coin?.symbol} ${maskCurrency(client?.creditUsed ?? 0, client.coin)}`
    : ""
}
${getBoard()}
`)
        .split('\n')
        .filter((l) => l)
        .join('\n')
}
